module.exports = __webpack_public_path__ + "img/Achievement.215bdcf9.svg";